import * as React from 'react';
import * as Classes from '../common/classes';
import { CalloutIntentStyle, IProps } from '../common/props';
import classNames from 'classnames';
import { Icon } from '../icon/Icon';
import {
  mcDangerFilled,
  mcInfoFilled,
  mcSuccessFilled,
  mcWarningFilled,
} from '@mc/react-ui-icons';
import { InverseBgProvider } from '../theme/InverseBg';

export interface ICalloutProps extends Omit<IProps, 'title'> {
  /**
   * Napdis.
   */
  title?: React.ReactNode;
  /**
   * Typ informace.
   */
  intent?: CalloutIntentStyle;
  extra?: React.ReactNode;
  /**
   * Ve výchozím nastavení je ikona zobrazena, pokud ji nechcete zobrazit, nastavte tuto vlastnost na false.
   */
  icon?: boolean;
}

export type CalloutProps = ICalloutProps;

export class Callout extends React.PureComponent<CalloutProps> {
  render() {
    const {
      className,
      title,
      intent = 'default',
      children,
      extra,
      icon,
      ...other
    } = this.props;

    let iconComponent;
    if (icon !== false) {
      switch (intent) {
        case 'none':
        case 'default':
        case 'info':
        case 'filter':
          iconComponent = <Icon fixedWidth icon={mcInfoFilled} />;
          break;
        case 'danger':
          iconComponent = <Icon fixedWidth icon={mcDangerFilled} />;
          break;
        case 'success':
          iconComponent = <Icon fixedWidth icon={mcSuccessFilled} />;
          break;
        case 'warning':
          iconComponent = <Icon fixedWidth icon={mcWarningFilled} />;
          break;
      }
    }

    return (
      <InverseBgProvider
        inverse={
          intent === 'success' ||
          intent === 'danger' ||
          intent === 'warning' ||
          intent === 'info' ||
          intent === 'filter'
        }
      >
        <div
          {...other}
          className={classNames(className, Classes.CALLOUT, {
            [Classes.CALLOUT_HAS_TITLE]: !!title,
            [Classes.CALLOUT_NONE]: intent === 'none',
            [Classes.CALLOUT_DEFAULT]: intent === 'default',
            [Classes.CALLOUT_INFO]: intent === 'info',
            [Classes.CALLOUT_SUCCESS]: intent === 'success',
            [Classes.CALLOUT_DANGER]: intent === 'danger',
            [Classes.CALLOUT_WARNING]: intent === 'warning',
            [Classes.CALLOUT_FILTER]: intent === 'filter',
          })}
        >
          {iconComponent && (
            <div className={Classes.CALLOUT_ICON}>{iconComponent}</div>
          )}
          <div className={Classes.CALLOUT_CONTENT_WRAPPER}>
            <div className={Classes.CALLOUT_BODY}>
              <div>
                {title && <div className={Classes.CALLOUT_TITLE}>{title}</div>}
                <div className={Classes.CALLOUT_CONTENT}>{children}</div>
              </div>
            </div>
            {extra && (
              <div className={classNames(Classes.CALLOUT_EXTRA, {})}>
                {extra}
              </div>
            )}
          </div>
        </div>
      </InverseBgProvider>
    );
  }
}
